"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class IsFqdnValidator {
    constructor(options) {
        this.options = options;
    }
    isValid(input) {
        if (input) {
            return validatorJS.isFQDN(input, this.options);
        }
        return false;
    }
}
exports.IsFqdnValidator = IsFqdnValidator;
//# sourceMappingURL=IsFqdnValidator.js.map